export default state => state.geolocation.fetchingCoordinatesPending;
